import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const IconWithMargin = styled(FontAwesomeIcon)`
  margin-right: ${({ theme: { mp } }) => mp.xs};
  margin-left: ${({ theme: { mp } }) => mp.xs};
`
